<footer *ngIf="enabled" [class.visible]="cssLoaded"></footer>
